core.directive('nipValidator', [
        function() {
            var definition = {
                require: 'ngModel',
                link: function(scope, elm, attrs, ctrl) {
                    ctrl.$validators.nipValidator = function(modelValue, viewValue) {
                        if (_.isEmpty(modelValue)) {
                            return true;
                        }

                        var nipRegex = /^\d{10}|\d{3}\-\d{3}\-\d{2}\-\d{2}|\d{3}\-\d{2}\-\d{2}\-\d{3}$/;

                        if (nipRegex.test(modelValue) === false) {
                            return false;
                        }

                        var nipWithoutDashes = modelValue.replace(/\-/g, '');
                        var weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
                        var checkDigit = parseInt(nipWithoutDashes[weights.length]);
                        var checksum = 0;

                        for (var i = 0; i < weights.length; i++) {
                            checksum += nipWithoutDashes[i] * weights[i];
                        }

                        checksum %= 11;

                        return checksum === checkDigit;
                    }
                }
            };

            return definition;
        }]
);